import { Button, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { $user, $app } from 'signals/global.signals';
import {
  FOUNDER_PATHS,
  INVESTOR_PATHS,
} from 'components/global/Header/Header.helpers';
import { useEffect, useState } from 'react';

const Sidebar = () => {
  const path = window.location.pathname;
  const navigate = useNavigate();
  const [paddingClass, setPaddingClass] = useState('pt-8');

  useEffect(() => {
    const updatePadding = () => {
      const height = window.innerHeight;
      if (height < 600) setPaddingClass('pt-8 overflow-y-scroll');
      else if (height < 700) setPaddingClass('pt-8 overflow-y-scroll');
      else if (height < 800) setPaddingClass('pt-32');
      else setPaddingClass('pt-40');
    };

    updatePadding(); // Set initial value
    window.addEventListener('resize', updatePadding);
    return () => window.removeEventListener('resize', updatePadding);
  }, []);
  const paths = $user.value.userType === 'founder' ? FOUNDER_PATHS : INVESTOR_PATHS;

  const checkPath = (pathname, related) => {
    const linkActive = 'fw-600 m-0 text-gradient-warning-white';
    const linkMuted = 'fw-300 m-0';
    return path.includes(pathname) || related?.filter(e => path.includes(e))?.length ? linkActive : linkMuted;
  };

  const clearAndNavigate = (newPath) => {
    navigate(newPath);
  };

  return (
    <div
      className={` left-menu h-100 bg-dark ${paddingClass} ps-24 pe-lg-0 pe-md-24 ${$app.value.isMenuOpen ? 'expanded' : ''}`}
      style={{
        scrollbarWidth: 'none',
          msOverflowStyle: 'none',
      }}
    >
      {paths.map((e, i) => (
        <Button
          key={i}
          className="zoom bg-transparent d-flex align-items-center text-start border-0 mb-40 p-4"
          onClick={() => clearAndNavigate(e.path)}
        >
          <Image
            className="me-8"
            src={e.icon}
            alt={e.name}
            width={18}
            height={18}
            style={{
              width: 18,
              height: 18,
              display: 'block',
            }}
          />
          <span className={checkPath(e.path, e.related)}>{e.name}</span>
        </Button>
      ))}
      <div style={{height:60}}> </div>
    </div>
  );
};

export default Sidebar;
